<template>
<card size="small" class="mt-5 ml-5 mr-5" v-show="shouldShow">
    <template slot="body">
        <div class="flex ai-c">
            <router-link to="/">Home</router-link>
            <span class="gray-message ml-1 mr-1">~</span>
            {{ $route.meta.title }}
        </div>
    </template>
</card>
</template>

<script>
import store from "@/store"

export default {
    name: "breadcrumbs",

    computed: {
        isHome () {
            return this.$route && this.$route.path === "/"
        },

        shouldShow () {
            return this.token && !this.isHome
        },

        token () {
            return store.state.token
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumbs.vue